import React from 'react';
import { motion } from 'framer-motion';
import { Award } from 'lucide-react';
export function ExpertSection() {
  return <section className="py-24 bg-[#1a3a52] text-white" data-id="element-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="bg-[#0f2942] rounded-3xl p-8 md:p-12 border border-[#C9A961]/30 shadow-2xl flex flex-col md:flex-row items-center gap-12" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="w-full md:w-1/3 flex-shrink-0" data-id="element-23">
            <div className="relative" data-id="element-24">
              <div className="absolute inset-0 bg-[#C9A961] rounded-2xl transform rotate-6 opacity-20" data-id="element-25" />
              <img src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Expert Author" className="relative rounded-2xl shadow-xl w-full object-cover aspect-[3/4]" data-id="element-26" />
              <div className="absolute -bottom-6 -right-6 bg-[#C9A961] text-[#1a3a52] p-4 rounded-xl shadow-lg flex items-center gap-3" data-id="element-27">
                <Award size={24} data-id="element-28" />
                <span className="font-bold text-sm" data-id="element-29">Estratega DTC</span>
              </div>
            </div>
          </motion.div>

          <div className="w-full md:w-2/3" data-id="element-30">
            <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-31">
              Carlos Rodríguez
            </h2>
            <p className="text-[#C9A961] font-serif italic text-xl mb-6" data-id="element-32">
              Especialista en Comunicación Estratégica
            </p>

            <div className="space-y-4 text-gray-300 leading-relaxed" data-id="element-33">
              <p data-id="element-34">
                No soy un gurú motivacional. Soy un estratega obsesionado con la
                estructura.
              </p>
              <p data-id="element-35">
                He trabajado con más de 3,000 profesionales que sabían{' '}
                <strong className="text-white" data-id="element-36">qué decir</strong>... pero no{' '}
                <strong className="text-white" data-id="element-37">cómo decirlo</strong> para que
                las cosas pasaran.
              </p>
              <p data-id="element-38">
                He visto carreras estancarse no por falta de talento, sino por
                falta de claridad. Creé este sistema para eliminar la fricción
                entre tus ideas y la acción de los demás.
              </p>
              <p className="font-medium text-white" data-id="element-39">
                Si aplicas estas estructuras, dejarás de ser ignorado. Es así de
                simple.
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-[#C9A961]/20 flex gap-8" data-id="element-40">
              <div data-id="element-41">
                <span className="block text-3xl font-bold text-white" data-id="element-42">3k+</span>
                <span className="text-sm text-gray-400" data-id="element-43">Profesionales</span>
              </div>
              <div data-id="element-44">
                <span className="block text-3xl font-bold text-white" data-id="element-45">
                  100%
                </span>
                <span className="text-sm text-gray-400" data-id="element-46">Práctico</span>
              </div>
              <div data-id="element-47">
                <span className="block text-3xl font-bold text-white" data-id="element-48">0%</span>
                <span className="text-sm text-gray-400" data-id="element-49">Relleno</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}